import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BackOfficeHome } from 'src/app/Services/Api.BackOfficeHome/BackOfficeHome';
import { MantenedorSucursalListComponent } from '../mantenedor-sucursal-list/mantenedor-sucursal-list.component';
import { OpenModal } from 'src/app/OpenModal';
import { RespuestaItem } from '../../../../../../src/app/Models/Shared/Respuesta';
import {ServicesCommon} from '../../../../Services/Api.Common/ServicesCommon';
import { BilleteraService } from '../../../../Services/Api.Billetera/BilleteraService'

@Component({
  selector: 'app-mantenedor-sucursal-edit',
  templateUrl: './mantenedor-sucursal-edit.component.html',
  styleUrls: ['./mantenedor-sucursal-edit.component.css']
})
export class MantenedorSucursalEditComponent implements OnInit {

  municipios: any[] = [];
  departamentos: any[] = [];
  Form: FormGroup;
  Submitted = false;
  Guardar = false;
  Loading = false;

  constructor(private _BilleteraService: BilleteraService,private fb: FormBuilder, private _BackOfficeHome: BackOfficeHome, 
    public dialogRef: MatDialogRef<MantenedorSucursalListComponent>, 
    private OModal: OpenModal, @Inject(MAT_DIALOG_DATA) public data: 
    any,private _Common: ServicesCommon) {       
    this.Form = this.fb.group({
      sucursalID: [data.sucursalID],
      nombre: [data.nombre],
      codificacion: [data.codificacion],
      direccion: [data.direccion],
      departamento: [data.departamentoID],
      municipio: [data.municipioID],
      personaContacto: [data.personaContacto],
      telefonoFijoContacto: [data.telefonoFijoContacto],
      telefonoCelularContacto: [data.telefonoCelularContacto],
      eMailContacto: [data.eMailContacto,[Validators.email]],
    })
  }

  ngOnInit() {
    this.onObtenerDepartamento();
    this.onObtenerMunicipio();
  }

  onCancelar() {
    this.dialogRef.close();
  }

  onEdit() {
    this.Submitted = true;
    if (this.Form.valid === false) {
      return false;
    }
    this.Loading = true;
    this.data = {
      comercioID: this.data.comercioID,
      sucursalID: this.data.sucursalID,
      nombre: this.Form.get('nombre').value,
      codificacion: this.Form.get('codificacion').value,
      direccion: this.Form.get('direccion').value,
      departamentoID: this.Form.get('departamento').value,
      municipioID: this.Form.get('municipio').value,
      personaContacto: this.Form.get('personaContacto').value,
      telefonoFijoContacto: this.Form.get('telefonoFijoContacto').value,
      telefonoCelularContacto: this.Form.get('telefonoCelularContacto').value,
      eMailContacto: this.Form.get('eMailContacto').value,
      activo: true
    };
    this._BilleteraService.actualizarSucursal(this.data).subscribe(res => {
      const artcl: RespuestaItem = res;
      if (artcl.record != null) {
        this.dialogRef.close(true);
      }
    },
      err => {
        console.error(err);
      }, () => this.Loading = false
    );
  }

  filter(event){
    var Departamento = event.value;
    this.municipios = this.municipios.filter(a=> {return a.departamentoID == Departamento})
  }

  onObtenerDepartamento() {
    this._Common.Departamento().subscribe(res => {
      const record = (res as any).recordset;
      if (record != null) 
        this.departamentos = record;      
    },
    err => {
        console.warn(err);
    });
  }

  onObtenerMunicipio() {
    this._Common.Municipio().subscribe(res => {
      const record = (res as any).recordset;
      if (record != null) 
        this.municipios = record;      
    },
    err => {
        console.warn(err);
    });
  }

  limit(element,max_chars){      
    let name = element.target.getAttribute('formcontrolname');  
    let valor = this.Form.get(name).value.toString();    
    if(valor.length > max_chars) 
      this.Form.get(name).setValue(valor.substr(0, max_chars));    
  }

}

